export const CalculateFunctionType = {
  ModbusDatetime: 1,
};
